namespace $.$$ {
	export class $shm_hitalama_range extends $.$shm_hitalama_range {
		
		range_width(): string {
			return this.vertical() ? '100cqw' : '100cqw'
		}
		
		range_height(): string {
			return this.vertical() ? '100cqw' : 'auto'
		}
		
		range_top(): string {
			return '0'
		}
		
		range_transform(): string {
			return this.vertical() ? 'rotate(270deg)' : ''
		}
		
		range_transformOrigin(): string {
			return this.vertical() ? '0' : ''
			// return this.vertical() ? '50cqh 50cqh' : ''
		}

		range_translate(): string {
			return this.vertical() ? '50cqw 50cqw' : ''
		}
		
	}
}
